// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "fun.tobi",
    name: "Tobi",
    homepage: "https://tobi.fun",
    image_id: "3cd2d066-56f7-4272-4a98-b39b41ea8200",
    app: {
        browser: "https://t.me/TobiWalletBot",
        ios: "https://t.me/TobiWalletBot",
        android: "https://t.me/TobiWalletBot",
        mac: "https://t.me/TobiWalletBot",
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: null,
        universal: "https://api.tobiwallet.app/dapp/wallet-connect/redirect",
    },
    desktop: {
        native: null,
        universal: "https://api.tobiwallet.app/dapp/wallet-connect/redirect",
    },
};
//# sourceMappingURL=index.js.map